module.exports = __webpack_public_path__ + "static/media/icon-doc.08fe8b29.svg";